/**
 * 제재관리 > 현황의 감시 파트 — -6차 부정발급(짜고치기) 현황.
 *
 *   KPI · 의심도 분포 · 한 패로 묶인 무리 · 자주 지목되는 회원 · 배점 설명 · 지금 다시 스캔
 *
 * 케이스를 **판정하는 목록은 알림 모아보기**(`/adm/tasks?type=collusion`)에 있다 — 여기 있던
 * 짜고치기·재발주 탭을 그리로 옮겼다. 무리를 누르면 모아보기에서 그 무리의 쌍만 연다.
 *
 * 차트는 라이브러리 없이 CSS 막대로 그린다(-6차 화면과 같은 방식).
 */
import Util from '../../../Common/Util';
export default class Collusion {
    /** @param {object} page $j.Pages.Admin.Penalty 인스턴스 */
    constructor(page) {
        this.page = page;
        this.cfg  = null; // 배점표 (summary 응답에 실려온다)
    }

    /** 페이지가 열릴 때 한 번. 현황은 첫 탭이라 바로 불러온다 */
    start() {
        $('#coRescan').on('click', () => this._rescan());

        this._loadStats();
    }

    destroy() {}

    // ─────────────────────────────────────────────── 현황

    async _loadStats() {
        try {
            const r = await $.ajax({ url: '/adm/ajax/collusion/summary', type: 'get', dataType: 'json' });
            if (!r.ok) return;
            this.cfg = r.config;
            this._case.config({ cfg: this.cfg });   // 상태 라벨은 모달도 같은 것을 본다
            this._renderKpi(r);
            this._renderBand(r.byScore);
            this._renderRings(r.rings);
            this._renderTop(r.top);
            this._renderScoring(r.config);
        } catch (e) {
            console.error('-6차 부정발급 현황 로드 실패', e);
        }
    }

    _renderKpi(r) {
        const k = r.kpi;
        const byType = {};
        (r.byType || []).forEach(t => byType[t.cs_type] = t);

        // KPI 카드는 관리자 공용 컴포넌트(.ms-kpi-*) 를 그대로 쓴다
        const card = (label, value, sub, cls) => `
            <div class="ms-kpi-card ${cls || ''}">
                <div class="ms-kpi-label">${label}</div>
                <div class="ms-kpi-value">${value}</div>
                <div class="ms-kpi-sub">${sub || '&nbsp;'}</div>
            </div>`;

        const scanned = k.scannedAt ? k.scannedAt.slice(0, 16) : '아직 스캔 전';
        $('#coKpi').html(
            card('미판정 케이스', this._n(k.new + k.check) + '<small>건</small>',
                 `미판정 ${this._n(k.new)} · 검토중 ${this._n(k.check)}`, k.new > 0 ? 'is-warn' : '') +
            card(`${this.cfg ? this.cfg.notableScore : 40}점 이상`, this._n(k.notable) + '<small>건</small>',
                 '먼저 봐야 할 케이스') +
            card('짜고치기', this._n((byType.pair || {}).cnt || 0) + '<small>건</small>',
                 `-6차 ${this._n((byType.pair || {}).msix_cnt || 0)}건 취득`) +
            card('재발주', this._n((byType.reorder || {}).cnt || 0) + '<small>건</small>',
                 `-6차 ${this._n((byType.reorder || {}).msix_cnt || 0)}건 취득`) +
            card('처리 완료', this._n(k.punish + k.clear) + '<small>건</small>',
                 `제재 ${this._n(k.punish)} · 정상 ${this._n(k.clear)}`) +
            card('마지막 스캔', `<span class="co-when">${scanned}</span>`, '매일 자정 배치 + 수동 스캔')
        );
    }

    /** 의심도 분포 — 어디에 선을 그을지 눈으로 정한다 */
    _renderBand(bands) {
        const order = ['70+', '50-69', '40-49', '30-39', '0-29'];
        const map = {};
        (bands || []).forEach(b => map[b.band] = parseInt(b.cnt));
        const max = Math.max(1, ...Object.values(map));
        if (!Object.keys(map).length) { $('#coScoreBand').html(this._empty('미판정 케이스가 없습니다.')); return; }

        $('#coScoreBand').html(order.map(b => {
            const v = map[b] || 0;
            return `<div class="co-band">
                        <span class="co-band-label">${b}점</span>
                        <span class="co-band-bar"><i style="width:${Math.round(v / max * 100)}%" class="${this._bandCls(b)}"></i></span>
                        <span class="co-band-val">${this._n(v)}</span>
                    </div>`;
        }).join(''));
    }

    _bandCls(b) {
        if (b === '70+')   return 'is-high';
        if (b === '50-69') return 'is-mid';
        if (b === '40-49') return 'is-low';
        return 'is-none';
    }

    /** 무리 — 눌러서 그 무리의 쌍만 본다 */
    _renderRings(rings) {
        if (!rings || !rings.length) {
            $('#coRings').html(this._empty('3명 이상으로 이어진 무리는 아직 없습니다.'));
            return;
        }
        $('#coRings').html(`<table class="table table-sm mb-0 co-mini">
            <thead><tr><th>구성원</th><th class="text-center">쌍</th><th class="text-center">거래</th>
                       <th class="text-center">-6차</th><th class="text-center">최고점</th></tr></thead>
            <tbody>${rings.map(r => `
                <tr class="co-ring-row" data-ring="${r.ring_no}">
                    <td>${(r.members || []).map(m =>
                        `<span class="co-chip">${this._esc(m.mem_name || '')}<small>${m.sido || ''}</small></span>`).join('')}</td>
                    <td class="text-center">${r.pair_cnt}</td>
                    <td class="text-center">${r.deal_cnt}</td>
                    <td class="text-center">${r.msix_cnt}</td>
                    <td class="text-center"><span class="co-score ${this._scoreCls(r.top_score)}">${r.top_score}</span></td>
                </tr>`).join('')}</tbody></table>`);

        // 무리 → 모아보기에서 그 무리의 쌍만 (판정 목록이 그리로 옮겨갔다). 판정한 것까지 다 본다.
        // 뒤로가기로 현황에 돌아와야 하니 replace 가 아니라 이동이다(관리자 PC 화면)
        $('#coRings').off('click', '.co-ring-row').on('click', '.co-ring-row', (e) => {
            const q = new URLSearchParams({ type: 'collusion', cs_type: 'pair', status: 'all', minScore: '',
                                            ring: $(e.currentTarget).data('ring') });
            location.href = '/adm/tasks?' + q.toString();
        });
    }

    _renderTop(top) {
        if (!top || !top.length) { $('#coTop').html(this._empty('지목된 회원이 없습니다.')); return; }
        $('#coTop').html(`<table class="table table-sm mb-0 co-mini">
            <thead><tr><th>회원</th><th>지역</th><th class="text-center">걸린 케이스</th>
                       <th class="text-center">-6차 취득</th><th class="text-center">최고점</th></tr></thead>
            <tbody>${top.map(t => `
                <tr>
                    <td>${$j.F.Admin.Member.Pop.cell(t.mb_no, t.mem_name)}</td>
                    <td>${this._esc(t.sido || '')}</td>
                    <td class="text-center">${t.case_cnt}</td>
                    <td class="text-center">${t.msix_cnt}</td>
                    <td class="text-center"><span class="co-score ${this._scoreCls(t.top_score)}">${t.top_score}</span></td>
                </tr>`).join('')}</tbody></table>`);
    }

    _renderScoring(cfg) {
        const tbl = (title, rows) => `
            <div class="co-score-help">
                <h6>${title}</h6>
                ${rows.map(r => `<div class="co-help-row">
                        <span class="co-help-max">${r.max}점</span>
                        <b>${this._esc(r.label)}</b>
                        <span class="text-muted">${this._esc(r.desc)}</span>
                    </div>`).join('')}
            </div>`;

        $('#coScoring').html(
            `<div class="text-muted mb-2" style="font-size:12.5px">
                최근 <b>${cfg.windowDays}일</b> 작업분을 매일 다시 계산합니다. 짜고치기는 거래 <b>${cfg.minDeals}건</b>부터 케이스가 됩니다.
                점수는 우선순위일 뿐 판정이 아닙니다 — 근거 오더를 열어 확인하고 사람이 정합니다.
             </div>` +
            tbl('짜고치기 (패턴1)', cfg.pair) + tbl('재발주 (패턴2)', cfg.reorder)
        );
    }

    async _rescan() {
        const $btn = $('#coRescan').prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> 스캔 중');
        try {
            const r = await $.ajax({ url: '/adm/ajax/collusion/rescan', type: 'post', dataType: 'json' });
            Util.swalert(r.message || '스캔했습니다.');
            this._loadStats();
        } catch (e) {
            Util.swalert('스캔에 실패했습니다.');
        } finally {
            $btn.prop('disabled', false).html('<i class="fas fa-sync"></i> 지금 다시 스캔');
        }
    }

    /* ── 케이스 모달 · 목록칸 렌더는 공용 모듈이 갖는다 ──────────────
       $j.F.Admin.Collusion.Case — 알림 모아보기(/adm/tasks)도 같은 창을 연다.
       표와 모달이 같은 함수를 봐야 같은 케이스를 같은 말로 적는다. */

    get _case() { return $j.F.Admin.Collusion.Case; }

    _scoreCls(score) { return this._case.scoreCls(score); }
    _empty(msg)      { return this._case.empty(msg); }
    _n(v)            { return this._case.n(v); }
    _esc(str)        { return this._case.esc(str); }
}
